import { EvidenceRegulatoryFootnote } from '@heidi/evidence';

import { useEvidenceIfuHref } from './useIsEvidenceIfuVisible';

import type { JSX } from 'react';

export interface EvidenceRegulatoryFootnoteWithIfuProps {
  className?: string;
}

/**
 * The Evidence regulatory footnote for the signed-in user: hands the package
 * component the Instructions For Use for their effective Evidence region, or
 * none when that region ships no IFU.
 */
export const EvidenceRegulatoryFootnoteWithIfu = ({
  className,
}: EvidenceRegulatoryFootnoteWithIfuProps): JSX.Element => (
  <EvidenceRegulatoryFootnote ifuHref={useEvidenceIfuHref()} className={className} />
);
